import { useMemo, useState } from "react";
import useDebounce from "./useDebounce";
import useDetectCurrentCulture from "./useDetectCurrentCulture";
import { useWindow } from "./useWindow";
import { useApi } from "./useAPI";
const useSearchInputWithSuggestions = (searchPageURL) => {
    const { culture } = useDetectCurrentCulture();
    const baseSearchUrl = searchPageURL || `/${culture}/search?searchtext=`;
    const { get, loading, setLoading } = useApi();
    const [searchValue, setSearchValue] = useState("");
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const myWindow = useWindow();
    const { debounceFn } = useDebounce({ delay: 200 });
    const getAndSetSearchSuggestions = async (value) => {
        const response = await get(`api/${culture}/typeahead`, { params: { searchtext: value || null } }).json();
        setSearchSuggestions(response);
        setLoading(false);
    };
    const debouncedSearch = useMemo(() => debounceFn(getAndSetSearchSuggestions), [culture]);
    const handleSearchChanges = (value) => {
        setLoading(true);
        setSearchSuggestions([]);
        setSearchValue(value);
        if (!!value) {
            debouncedSearch(value);
        }
    };
    const handleSearchEnter = (key) => {
        if (key === "Enter") {
            myWindow.location.href = `${baseSearchUrl}${searchValue}`;
        }
    };
    return {
        loading,
        searchSuggestions,
        baseSearchUrl,
        searchValue,
        handleSearchChanges,
        handleSearchEnter,
        getAndSetSearchSuggestions
    };
};
export default useSearchInputWithSuggestions;
